import React from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { BarChart, CustomButtonGroup } from '../../../shared';
import { CHART_OPTIONS } from './constants';
import { useSelector,useDispatch } from 'react-redux';
import { actions as webMatrixActions } from '../../../../redux/reducers/webMatrixReducer';
import { primaryColors } from '../../../../constants';

function EngagementChannel() {
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { clickEngagement, isWebMatrixPatientLoading } = dtcData;
    const dispatch = useDispatch();

    const { setDigitalPhysicianEngagementChannel, setDigitalPhysicianEngagementData } = webMatrixActions;
    const handleChannel = (option) => {
        dispatch(setDigitalPhysicianEngagementChannel(option));
        dispatch(setDigitalPhysicianEngagementData(option));
    };
    console.log(clickEngagement,'clickEngagement');
    return (
        <Grid className='box-sizing-border-box bg-gray-50 height-100 br-16px'>
            <Box className="flex-column gap-8 padding-24px border-bottom-gray">
                <Box>
                    <Typography className="text-md-medium gray-900">
                        Engagement by Channels
                    </Typography>
                </Box>
                <Box>
                    { isWebMatrixPatientLoading
                        ? <Skeleton height={40} variant='rectangular' width={'100%'}/> 
                        : clickEngagement.labels.length > 1 ? (<CustomButtonGroup
                            customStyle={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            data={clickEngagement.labels}
                            handleClick={(option)=>handleChannel(option)}
                            isToolTip={true}
                            key="digital-physician-engagement-by-channels"
                            selected={clickEngagement.selectedChannel}
                        />) : null
                    }
                </Box>
            </Box>

            <Grid
                container
                spacing={2}
            >
                <Grid item xs={12}>
                    <Box className="padding-24px min-height-370px physician-engagement-channels">
                        { isWebMatrixPatientLoading ? <Skeleton height={400} variant="rectangular" width='100%' /> : <BarChart
                            chartOptions={
                                {
                                    ...CHART_OPTIONS,
                                    xaxis: {
                                        ...CHART_OPTIONS.xaxis,
                                        categories: clickEngagement.selectedChannel === 'All' ? [...clickEngagement.categoriesForAll] : [...clickEngagement.categories]
                                    },
                                    yaxis: {
                                        ...CHART_OPTIONS.yaxis,
                                        max: clickEngagement.yMax
                                    },
                                    colors: primaryColors,
                                    chart: clickEngagement.selectedChannel === 'All' ? CHART_OPTIONS.chart : { stacked: false, toolbar: { show: false } }
                                }
                            }
                            chartSeries={clickEngagement.series}
                        />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default EngagementChannel;
